/* global SyntheticInputEvent, HTMLElement, HTMLInputElement, HTMLFormElement */ function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { Component } from "react";
import RichtextEditor from "./RichtextEditor";
import AssetElement from "./Asset";
import UploadQueue from "../utils/UploadQueue";
import Log from "../utils/Log";
import isEqual from "lodash/isEqual";
import throttle from "lodash/throttle";
import pick from "lodash/pick";
import SocialAPIUtils from "../utils/SocialAPIUtils";
import { injectIntl } from "react-intl";
import Icon from "./Icon";
import classNames from "classnames";
import { getCurrentTopic, isTopicPersisted } from "../utils/SocialTopicsUtils";
var ActivityEditor = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ActivityEditor, Component);
    var _super = _createSuper(ActivityEditor);
    function ActivityEditor(props) {
        _classCallCheck(this, ActivityEditor);
        var _this;
        _this = _super.call(this, props);
        _this.renderFormErrors = function() {
            var errors = _this.state.errors;
            var intl = _this.props.intl;
            return /*#__PURE__*/ React.createElement("ul", {
                className: "social-activity-editor__errors"
            }, errors && Object.keys(errors).map(function(key) {
                return /*#__PURE__*/ React.createElement("li", {
                    key: key,
                    className: "social-activity-editor__error"
                }, intl.formatMessage({
                    id: "social.activities.validations." + key + "." + errors[key][0],
                    defaultMessage: errors[key][0]
                }) || "".concat(key, ": ").concat(errors[key][0]));
            }));
        };
        _this._handleAction = function(eventName) {
            var _this_props = _this.props, intl = _this_props.intl, sendAlert = _this_props.sendAlert;
            switch(eventName){
                case "save":
                    if (!_this.state.isSaving) {
                        throttle(_this._doSave, 200)();
                    } else {
                        sendAlert(intl.formatMessage({
                            id: "social.activities.action_not_possible_while_saving",
                            defaultMessage: "Action not possible while saving"
                        }), "warning");
                    }
                    break;
                case "cancel":
                    if (!_this.state.isSaving) {
                        _this._doCancel();
                    } else {
                        sendAlert(intl.formatMessage({
                            id: "social.activities.action_not_possible_while_saving",
                            defaultMessage: "Action not possible while saving"
                        }), "warning");
                    }
                    break;
                default:
                    Log.log("What to do: " + eventName);
                    break;
            }
        };
        _this._doSave = function() {
            var _this_state = _this.state, activity = _this_state.activity, topic = _this_state.topic, deleteAssets = _this_state.deleteAssets, bodyHasChanged = _this_state.bodyHasChanged;
            var _this_props = _this.props, isTopic = _this_props.isTopic, duplicate = _this_props.duplicate, sphere = _this_props.sphere;
            _this.setState({
                isSaving: true
            });
            // delete assets
            deleteAssets.forEach(function(id) {
                return SocialAPIUtils.deleteAsset(activity, id);
            });
            var promise;
            if (isTopic && sphere) {
                // Topic persistence logic
                if (isTopicPersisted(topic) && !duplicate) {
                    promise = SocialAPIUtils.updateTopic(topic, activity);
                } else {
                    var _activity = _objectSpread({}, activity);
                    if (!_activity.body && !bodyHasChanged) {
                        _activity.body = _this._getDefaultBody();
                    }
                    if (duplicate) {
                        promise = SocialAPIUtils.duplicateTopic(sphere, topic.title, _activity, duplicate);
                    } else {
                        promise = SocialAPIUtils.createTopic(sphere, topic.title, _activity);
                    }
                }
            } else {
                // Activity Persistence logic
                // Activity is persisted on server if id is >= 0
                if (activity.id >= 0) {
                    promise = SocialAPIUtils.updateActivity(activity, getCurrentTopic());
                } else {
                    promise = SocialAPIUtils.createActivity(activity, getCurrentTopic());
                }
            }
            if (promise) {
                promise.then(_this._onActivityPersisted, _this._onInvalidUpdate);
            }
        };
        _this._onInvalidUpdate = function(activityOrTopic) {
            var _this_props = _this.props, isTopic = _this_props.isTopic, sendAlert = _this_props.sendAlert, intl = _this_props.intl;
            sendAlert(isTopic ? intl.formatMessage({
                id: "social.activities.create_new_topic_failed",
                defaultMessage: "Failed to create Topic"
            }) : intl.formatMessage({
                id: "social.activities.create_new_answer_failed",
                defaultMessage: "Creating answers failed"
            }), "danger");
            _this.setState({
                errors: activityOrTopic.errorThrown && activityOrTopic.errorThrown.errors,
                isSaving: false
            });
        };
        _this._onActivityPersisted = function(activityOrTopic) {
            _this._startFileUpload(activityOrTopic);
        };
        _this._startFileUpload = function(activityOrTopic) {
            var _this_state = _this.state, topic = _this_state.topic, activity = _this_state.activity, queueItems = _this_state.queueItems;
            var _this_props = _this.props, isTopic = _this_props.isTopic, isNote = _this_props.isNote, intl = _this_props.intl, sendAlert = _this_props.sendAlert, fetchActivity = _this_props.fetchActivity, fetchNote = _this_props.fetchNote, fetchTopic = _this_props.fetchTopic;
            if (_this.queue.items().filter(function(i) {
                return i.status === "pending";
            }).length) {
                _this.queue.start(isTopic ? activityOrTopic.description : activityOrTopic).then(function() {
                    // TO DO: refactor this so an action is dispatched from container instead of directly calling SocialAPIUtils from here
                    // and also refactor async handling of the promise accordingly
                    if (isNote) {
                        SocialAPIUtils.getNote(activityOrTopic).then(function(_topic) {
                            _this._updateComplete(_topic.description, _topic);
                        });
                    } else if (isTopic) {
                        SocialAPIUtils.getTopic(activityOrTopic).then(function(_topic) {
                            _this._updateComplete(_topic.description, _topic);
                        });
                    } else {
                        SocialAPIUtils.getActivity(activityOrTopic, topic || getCurrentTopic()).then(function(_activity) {
                            _this._updateComplete(_activity, topic);
                        });
                    }
                }, function(err) {
                    console.log(err);
                    sendAlert(intl.formatMessage({
                        id: "social.activities.activity_error_notification",
                        defaultMessage: "Error"
                    }) + " - ".concat(err.errorThrown, " (").concat(err.status, ")"), "danger");
                    queueItems.forEach(function(qi) {
                        _this.queue._updateItem(qi.id, 0);
                    });
                    _this.setState({
                        isSaving: false
                    });
                });
            } else {
                _this._updateComplete(activity, topic);
            }
        };
        _this._updateComplete = function(activity, topic) {
            var _this_props = _this.props, intl = _this_props.intl, sendAlert = _this_props.sendAlert;
            sendAlert(intl.formatMessage({
                id: "social.activities.activity_saved_notification",
                defaultMessage: "Activity saved "
            }), "success");
            _this.setState({
                isSaving: false
            });
            if (_this.props.onSaved) {
                _this.props.onSaved(activity, topic);
            }
        };
        _this._onFileChange = function(evnt) {
            var _this_props = _this.props, intl = _this_props.intl, sendAlert = _this_props.sendAlert;
            if (evnt.target.files && evnt.target.files.length) {
                _this.queue.add(Array.from(evnt.target.files));
            }
            sendAlert(intl.formatMessage({
                id: "social.activities.asset_added_notification",
                defaultMessage: "Asset added"
            }), "success");
        };
        _this._doCancel = function() {
            if (_this.props.onCancel) {
                _this.props.onCancel();
            }
        };
        _this._getDefaultBody = function() {
            var _this_props = _this.props, currentSlide = _this_props.currentSlide, isNote = _this_props.isNote, isTopic = _this_props.isTopic, intl = _this_props.intl;
            return !!currentSlide && isTopic ? '<p> </p><p class="social-activity__signature">'.concat(intl.formatMessage({
                id: "social.activities.this_msg_links_to_chart_",
                defaultMessage: "This Activity was written on slide: {link}"
            }, {
                link: currentSlide ? _this._getNodeLink(currentSlide) : null,
                isNote: isNote || false
            }), "</p>") : "";
        };
        _this._getNodeLink = function(item) {
            return '<a href="#" class="social-activity__mention icon-photos icon-photos--white" data-node-ref="'.concat(item.id, '">').concat(item.name, "</a>");
        };
        _this._onActivityBodyChanged = function(newContent) {
            var newActivity = _objectSpreadProps(_objectSpread({}, _this.state.activity), {
                body: newContent
            });
            _this.setState({
                activity: newActivity,
                bodyHasChanged: true
            });
        };
        _this._onTopicTitleChanged = function(evnt) {
            var title = evnt.target.value;
            _this.setState({
                topic: _objectSpreadProps(_objectSpread({}, _this.state.topic), {
                    title: title
                })
            });
        };
        _this._onToggleAsset = function(asset) {
            var _this_props = _this.props, intl = _this_props.intl, sendAlert = _this_props.sendAlert;
            if (!asset.status) {
                var _da = _this.state.deleteAssets;
                var index = _da.indexOf(asset.id);
                if (index > -1) {
                    _da.splice(index, 1);
                } else {
                    sendAlert(intl.formatMessage({
                        id: "social.activities.delete_asset_notification",
                        defaultMessage: "Deleted Assets"
                    }), "warning", 8000);
                    _da.push(asset.id);
                }
                _this.setState({
                    deleteAssets: _da
                });
            } else {
                var fuf = document.getElementById("fileUploadFile");
                var fuForm = document.getElementById("fileUploadForm");
                if (_instanceof(fuf, HTMLInputElement)) {
                    fuf.value = "";
                }
                if (_instanceof(fuForm, HTMLFormElement)) {
                    fuForm.reset();
                }
                if (typeof asset.id === "string") {
                    _this.queue.remove(asset.id);
                }
            }
        };
        _this._queueChanged = function() {
            _this.setState({
                queueItems: _this.queue.items()
            });
        };
        _this.state = {
            activity: _objectSpread({}, props.activity),
            topic: _objectSpread({}, props.topic),
            deleteAssets: [],
            errors: null,
            bodyHasChanged: false,
            queueItems: [],
            isSaving: false
        };
        _this.queue = new UploadQueue();
        return _this;
    }
    var _proto = ActivityEditor.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.props.action.addListener("action", this._handleAction);
        this.queue.addChangeListener(this._queueChanged);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.action.removeListener("action", this._handleAction);
        this.queue.removeChangeListener(this._queueChanged);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this_props = this.props, activity = _this_props.activity, topic = _this_props.topic;
        if (!isEqual(prevProps.activity, activity)) {
            this.setState({
                activity: _objectSpread({}, activity)
            });
        }
        if (!isEqual(prevProps.topic, topic)) {
            this.setState({
                topic: _objectSpread({}, topic)
            });
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, isNote = _this_props.isNote, isTopic = _this_props.isTopic, sphere = _this_props.sphere, intl = _this_props.intl;
        var _this_state = this.state, errors = _this_state.errors, topic = _this_state.topic, activity = _this_state.activity, deleteAssets = _this_state.deleteAssets, queueItems = _this_state.queueItems, isSaving = _this_state.isSaving;
        var body = activity.body || this._getDefaultBody();
        var FileBtn = function() {
            return /*#__PURE__*/ React.createElement("form", {
                className: "icon-clip social-activity-editor__file",
                id: "fileUploadForm",
                onChange: _this._onFileChange,
                title: _this.state.queueItems.map(function(qi) {
                    return qi.name;
                }).join(", "),
                target: "cbkrmt_upload_target",
                method: "POST",
                encType: "multipart/form-data"
            }, /*#__PURE__*/ React.createElement("label", {
                className: "social-activity-editor__btn-label",
                htmlFor: "fileUploadFile"
            }, /*#__PURE__*/ React.createElement(Icon, {
                name: "attachment",
                size: "s"
            }), intl.formatMessage({
                id: "social.activities.add_asset",
                defaultMessage: "Add Asset"
            })), /*#__PURE__*/ React.createElement("input", {
                className: "social-activity-editor__upload",
                id: "fileUploadFile",
                type: "file",
                name: "file",
                disabled: isSaving,
                multiple: true
            }));
        };
        if (isSaving) {
            // Renders a loading icon to the UI.
            return /*#__PURE__*/ React.createElement("div", {
                className: "social-app-saving"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "social-app-saving__section-one"
            }), /*#__PURE__*/ React.createElement("div", {
                className: "social-app-saving__section-two"
            }), /*#__PURE__*/ React.createElement("div", {
                className: "social-app-saving__section-three"
            }), /*#__PURE__*/ React.createElement("div", {
                className: "social-app-saving__section-four"
            }));
        }
        var titleClasses = classNames("social-activity-editor__wrapper", {
            error: errors === null || errors === void 0 ? void 0 : errors.title
        });
        return /*#__PURE__*/ React.createElement("div", {
            className: "social-app-options"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "social-activity-editor"
        }, errors ? this.renderFormErrors() : null, isTopic ? /*#__PURE__*/ React.createElement("div", {
            className: titleClasses
        }, /*#__PURE__*/ React.createElement("input", {
            placeholder: "Titel",
            className: "social-activity-editor__title",
            type: "text",
            onChange: this._onTopicTitleChanged,
            value: topic.title,
            disabled: isSaving
        }), " ") : null, /*#__PURE__*/ React.createElement("div", {
            className: classNames("social-activity-editor__wrapper", {
                "has-error": !!errors && (!!errors.body || !!errors.description)
            })
        }, /*#__PURE__*/ React.createElement(RichtextEditor, {
            disabled: isSaving,
            mentions: this.props.slides.map(function(chart) {
                return pick(chart, [
                    "id",
                    "name"
                ]);
            }),
            text: body,
            onChange: this._onActivityBodyChanged,
            extraButtons: [
                FileBtn
            ]
        })), (!!activity.assets || !!queueItems.length) && /*#__PURE__*/ React.createElement("div", {
            className: "social-activity-editor__assets"
        }, queueItems.concat(activity.assets).map(function(a) {
            return a && /*#__PURE__*/ React.createElement(AssetElement, {
                asset: a,
                key: a.id,
                onToggle: _this._onToggleAsset,
                willBeDeleted: deleteAssets.indexOf(a.id) > -1
            });
        }))));
    };
    return ActivityEditor;
}(Component);
export default injectIntl(ActivityEditor);
